import { createContext } from 'react'

import { DEFAULT_DRAFT_CONTEXT_VALUE } from '../constants/draft'

export function createDraftContext() {
  return createContext(DEFAULT_DRAFT_CONTEXT_VALUE)
}
